import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Settings2 } from 'lucide-react';
import {
  THEMES,
  ZOOM_LEVELS,
  applyAccessibilityPrefs,
  loadAccessibilityPrefs,
  saveAccessibilityPrefs,
} from '../lib/accessibility';

const AccessibilityPanel = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [prefs, setPrefs] = useState(() => loadAccessibilityPrefs());
  const aboveMenu = pathname !== '/';

  useEffect(() => {
    applyAccessibilityPrefs(prefs);
    saveAccessibilityPrefs(prefs);
  }, [prefs]);

  // Au-dessus de la barre d'onglets (z-50) et du pied de page bureau, sinon le bouton disparaît derrière.
  const place = aboveMenu
    ? 'bottom-[calc(0.55rem+env(safe-area-inset-bottom,0px))] md:bottom-16'
    : 'bottom-[max(0.75rem,env(safe-area-inset-bottom,0px))] md:bottom-16';

  return (
    <div className={`fixed right-[calc(0.75rem+var(--sar))] z-[60] flex flex-col items-end md:right-[calc(1rem+var(--sar))] ${place}`} data-testid="accessibility-anchor">
      {open && (
        <div className="mb-2 max-h-[40vh] w-[min(18rem,calc(100vw-1.5rem))] overflow-y-auto rounded-lg border border-border bg-card p-4 shadow-lg">
          <h3 className="mb-3 text-sm font-bold uppercase tracking-wide text-foreground">
            Accessibilité
          </h3>
          <div className="mb-4">
            <label className="mb-1 block text-xs uppercase text-muted-foreground" htmlFor="a11y-theme">
              Couleurs
            </label>
            <select
              id="a11y-theme"
              value={prefs.theme}
              onChange={(e) => setPrefs(prev => ({ ...prev, theme: e.target.value }))}
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 text-sm text-foreground"
              data-testid="select-a11y-theme"
            >
              {THEMES.map(theme => (
                <option key={theme.id} value={theme.id}>{theme.label}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="mb-1 block text-xs uppercase text-muted-foreground" htmlFor="a11y-zoom">
              Zoom
            </label>
            <select
              id="a11y-zoom"
              value={prefs.zoom}
              onChange={(e) => setPrefs(prev => ({ ...prev, zoom: e.target.value }))}
              className="flex h-10 w-full rounded-md border border-input bg-background px-3 text-sm text-foreground"
              data-testid="select-a11y-zoom"
            >
              {ZOOM_LEVELS.map(level => (
                <option key={level.id} value={level.id}>{level.label}</option>
              ))}
            </select>
          </div>
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen(v => !v)}
        className="ml-auto flex h-11 w-11 items-center justify-center rounded-full border border-border bg-primary text-primary-foreground shadow-md hover:bg-primary/90 md:h-12 md:w-12 md:shadow-lg"
        aria-label="Ouvrir les options d'accessibilité"
        data-testid="btn-accessibility"
      >
        <Settings2 className="h-5 w-5" />
      </button>
    </div>
  );
};

export default AccessibilityPanel;
